import { Paper, IconButton } from "@mui/material"; // Import Material-UI components

import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

import {
  GoogleMap,
  InfoWindow,
  Marker,
  useLoadScript,
} from "@react-google-maps/api";
// import InfoWindowContent from "./InfoWindowContent";
import CustomLoading from "../utils/CustomLoading";
import axios from "axios";

const libraries = ["marker"];

const mapContainerStyle = {
  height: "83vh",
  width: "100%",
};
const defaultCenter = {
  lat: 26.2183, // Latitude for Gwalior
  lng: 78.1828, // Longitude for Gwalior
};

const GoogleMapModal = ({
  isModalOpen,
  setIsMapState,
  locationCoordinates,
  MapFor,
}) => {
  const serverURL = process.env.REACT_APP_URL;

  const [allLocations, setAllLocations] = useState([]);
  const getInstallationPartnerList = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/installationPartner/viewAllIpsMap`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response?.data?.success) {
        setAllLocations(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching InstallationPartner:", error);
    }
  };
  const getVendorList = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${serverURL}/api/vendorsForMap`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response?.data?.success) {
        setAllLocations(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };
  console.log(allLocations);

  useEffect(() => {
    if (MapFor === "installationPartner") {
      getInstallationPartnerList();
    } else {
      getVendorList();
    }
  }, [MapFor]);

  const [hoveredLocation, setHoveredLocation] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);

  // Use the libraries constant directly in useLoadScript
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY, // Your API Key
    libraries: libraries, // Use the constant here
  });

  if (loadError) return <div>Error loading maps</div>;

  if (!isLoaded) {
    // Show loader while the API is being loaded
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CustomLoading /> {/* Replace with your loader */}
      </div>
    );
  }

  const generateAvatarIcon = (name) => {
    const canvas = document.createElement("canvas");
    canvas.width = 100;
    canvas.height = 100;
    const ctx = canvas.getContext("2d");

    // Draw background circle
    ctx.fillStyle = "#418cff"; // MUI primary color
    ctx.beginPath();
    ctx.arc(50, 50, 40, 0, Math.PI * 2);
    ctx.fill();

    // Draw text (initials)
    ctx.fillStyle = "white";
    ctx.font = "bold 32px Arial";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(name.charAt(0).toUpperCase(), 50, 50);

    return canvas.toDataURL(); // Convert to base64 URL
  };
  return (
    <>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={6}
        center={defaultCenter}
        options={{
          mapTypeControl: false, // Disable map and satellite view options
          streetViewControl: false,
        }}
      >
        {allLocations?.map((location, index) => (
          <Marker
            key={index}
            position={{
              lat:
                location?.locationCoordinates?.latitude ||
                locationCoordinates?.lat,
              lng:
                location?.locationCoordinates?.longitude ||
                locationCoordinates?.lng,
            }}
            icon={{
              url: location?.vendorBusinessName
                ? "/factory.svg"
                : "/ipmapimage.svg",
              // : location.profilePhoto || generateAvatarIcon(location.name),
              scaledSize: new window.google.maps.Size(40, 40), // Resize SVG icon
              anchor: new window.google.maps.Point(20, 40), // Adjust anchor point
            }}
            onClick={() => setSelectedLocation(location)} // Only trigger on click
          />
        ))}

        {selectedLocation && (
          <InfoWindow
            position={{
              lat:
                selectedLocation?.locationCoordinates?.latitude ||
                hoveredLocation?.locationCoordinates?.latitude ||
                0,
              lng:
                selectedLocation?.locationCoordinates?.longitude ||
                hoveredLocation?.locationCoordinates?.longitude ||
                0,
            }}
            onCloseClick={() => {
              setSelectedLocation(null);
              setHoveredLocation(null);
            }}
          >
            <Paper
              elevation={1}
              sx={{
                width: 200,
                borderRadius: 1,
                margin: 0,
                padding: 0,
                overflow: "hidden",
                border: 1,
                // backgroundColor: selectedLocation?.vendorBusinessName
                //   ? "#05cd99"
                //   : "#f59e0b",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "8px",
                  backgroundColor: "#3B82f6",
                  borderRadius: "3px",
                }}
              >
                <h4
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "white",
                  }}
                >
                  {selectedLocation?.vendorBusinessName
                    ? "Vendor Details "
                    : "IP Details "}
                </h4>

                {/* Close Button */}
                <IconButton
                  size="small"
                  onClick={() => setSelectedLocation(null)}
                  style={{ color: "white" }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </div>
              {/* Details Section */}
              <div style={{ padding: "8px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    gap: "20px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      color: "black",
                      fontWeight: "800",
                    }}
                  >
                    Name
                  </span>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#555",
                      fontWeight: "600",
                    }}
                  >
                    {(() => {
                      let role = localStorage.getItem("role");
                      const text = selectedLocation?.vendorBusinessName
                        ? role == 1
                          ? "***" +
                            selectedLocation?.vendorBusinessName.slice(-5)
                          : selectedLocation?.vendorBusinessName
                        : "" || selectedLocation?.name
                        ? role == 1
                          ? "***" + selectedLocation?.name.slice(-5)
                          : selectedLocation?.name
                        : "" || "";
                      return text.charAt(0).toUpperCase() + text.slice(1);
                    })()}
                  </span>
                </div>
              </div>

              <div style={{ padding: "8px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    gap: "20px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      color: "black",
                      fontWeight: "800",
                    }}
                  >
                    Rating
                  </span>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#555",
                    }}
                  >
                    {(() => {
                      const starsCount =
                        selectedLocation?.reliability ??
                        selectedLocation?.ratings ??
                        0;
                      return starsCount > 0
                        ? Array.from({ length: starsCount })
                            .map((_, index) => "⭐")
                            .join(" ")
                        : "Not Available";
                    })()}
                  </span>
                </div>
              </div>
            </Paper>
          </InfoWindow>
        )}
      </GoogleMap>

      {/* Inject styles to hide the close button */}
      <style>
        {`
          .gm-ui-hover-effect {
            display: none !important; /* Hide the close button */
          }
          .gm-style-iw-d {
            padding: 0 !important; /* Remove padding from the InfoWindow content */
          }
        `}
      </style>
    </>
  );
};

export default GoogleMapModal;
